// extracted by mini-css-extract-plugin
export default {"container":"VoterMyProfile_container__3+IUc","header":"VoterMyProfile_header__NDRSh"};